import { SET_ERROR } from './../actions';

export const error = (state = {}, action) => {
    switch(action.type) {
        case SET_ERROR:{
            return action.payload;
        }
        default:
            return state;
    }
}